import React from "react";
import { Box, Container } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { CreatableZoneFile, emptyZoneFileItem } from "../../api/zoneFile";
import ZoneFileDetailsToolbar from "../../components/zoneFiles/ZoneFileDetailsToolbar";
import ZoneFileCreate from "../../components/zoneFiles/ZoneFileCreate";
import { useLoadingInfoState } from "../../components/Loading/useLoadableState";
import { useSnackbar } from "notistack";
import { performAsyncAction } from "../../components/Loading/useAsync";
import LoadingFullScreen from "../../components/Loading/LoadingFullScreen";
import useApiClient from "../../api/useApiClient";

const NewZoneFile = () => {
  const navigate = useNavigate();
  const [creatableZoneFile, setCreatableZoneFile] =
    React.useState<CreatableZoneFile>(emptyZoneFileItem);

  const [loadingInfo, setLoadingInfo] = useLoadingInfoState();

  const { enqueueSnackbar } = useSnackbar();
  const client = useApiClient();

  return (
    <>
      <Helmet>
        <title>New Zone File</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <ZoneFileDetailsToolbar
            name="New Zone File"
            canDelete={false}
            editing={creatableZoneFile !== undefined}
            onEdit={() => {
              // Do nothing
            }}
            onDelete={() => {
              // Do nothing
            }}
            onSave={() => {
              if (creatableZoneFile) {
                performAsyncAction(
                  () => client.zone.file.create(creatableZoneFile),
                  setLoadingInfo,
                  enqueueSnackbar,
                  () => navigate("/app/zoneFiles")
                );
              }
            }}
            onCancel={() => navigate("/app/zoneFiles")}
          />
          <Box sx={{ pt: 3 }}>
            <ZoneFileCreate
              value={creatableZoneFile}
              onChange={(x) => setCreatableZoneFile(x)}
            />
          </Box>
        </Container>
      </Box>
      <LoadingFullScreen loadingInfo={loadingInfo} />
    </>
  );
};

export default NewZoneFile;
